export enum Application {
    ESPP_QUOTER = 'ESPP Quoter',
    ESPP_QUOTE_QUEUE = 'ESPP Quote Queue',
    ESPP_QUOTE_DETAILS = 'ESPP Quote Details',
    ESPP_APPLICATION = 'ESPP Application',
    ESPP_ENROLLED_UNITS = 'ESPP Enrolled Units',
    ESPP_ENROLLED_UNIT_DETAIL = 'ESPP Enrolled Unit Detail',
    ESPP_CLAIMS = 'ESPP Claims',
}
